module.exports = __webpack_public_path__ + "img/496.5022fca9.jpg";